<template>
  <app-chart-wrapper data-padding="16px">

    <div class="overview-card-body">
      <div class="icon-wrapper"
           :style="{'background-color': backgroundColor}">
        <i class="mdi"
           :class="icon"
           :style="{color: color}"></i>
      </div>

      <div class="text-bold measure">
        {{value}}{{dataAppend}}
      </div>

      <h5 class="no-margin heading">
        {{dataHeading}}
      </h5>
    </div>

  </app-chart-wrapper>
</template>

<script>
    import AppChartWrapper from '@components/chart/ChartWrapper'
    import colors from '@packages/colors'

    export default {
        components: {
            AppChartWrapper,
        },

        props: {
            dataKey: {
                type: String,
                required: true,
            },

            dataHeading: {
                type: String,
                required: true,
            },

            dataIcon: {
                type: String,
                required: true,
            },

            dataIndex: {
                type: Number,
                required: true,
            },

            dataAppend: {
                type: String,
                required: false,
                default: ''
            }
        },

        computed: {
            value() {
                return new Intl.NumberFormat('pt-BR').format(this.$store.state.statistics.overview[this.dataKey]) 
            },

            icon() {
                return 'mdi-' + this.dataIcon
            },

            color() {
                return colors.overview.icons[this.dataIndex]
            },

            backgroundColor() {
                return colors.overview.backgrounds[this.dataIndex]
            },

            // todo this is not implemented on the back end application
            // isUp() {
            //     return true
            // },
            //
            // isDown() {
            //     return false
            // },
            //
            // percentageClasses() {
            //     return {
            //         'text-success': this.isUp,
            //         'text-danger': this.isDown,
            //     }
            // },
            //
            // arrow() {
            //     return this.isUp ? 'mdi-arrow-up' : 'mdi-arrow-down'
            // }
        }
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.overview-card-body {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  padding: 12px;

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    height: 32px;
    width: 32px;

    .mdi {
      font-size: 18px;
    }
  }

  .measure {
    font-size: 28px;
    margin: auto;
  }

  @media (max-width: $desktop-md-max) {
    padding: 0;

    .icon-wrapper {
      height: 28px;
      width: 28px;

      .mdi {
        font-size: 18px;
      }
    }

    .heading {
      font-size: 14px;
    }

    .measure {
      font-size: 22px;
    }
  }
}
</style>
